import type {
  DropDownSelectOption,
  SelectOption,
} from '../../../../components';

export function getOptionsLabel(
  options: Array<SelectOption | DropDownSelectOption>,
  value: string,
): string {
  const option = options.find(option => option.value === value);
  return option ? (option.label as string) : 'N/A';
}

export function getOptionsLabelClear(
  options: Array<SelectOption | DropDownSelectOption>,
  value: string,
): number | string | undefined {
  const option = options.find(option => option.value === value);
  return option?.label;
}

export function getOptionsValue(
  options: Array<SelectOption | DropDownSelectOption>,
  label: string,
): string {
  const option = options.find(option => option.label === label);
  return option ? option.value.toString() : 'N/A';
}

export function getNestOptionsLabel(
  options: SelectOption[],
  value: string | number,
): string {
  function findLabel(options: SelectOption[], value: string | number): string {
    for (const option of options) {
      if (option.children) {
        const label = findLabel(option.children, value);
        if (label !== 'N/A') {
          return label;
        }
      }
      if (option.value === value) {
        return option.label !== undefined ? String(option.label) : 'N/A';
      }
    }
    return 'N/A';
  }

  return findLabel(options, value);
}
